export const paasProducts = [
  {
    img: '04',
    name: '实时语音',
    desc: '轻松实现1对1、多对多实时语音通话'
  },
  {
    img: '05',
    name: '实时视频',
    desc: '多人视频通话，领先视频编解码技术极低延时不卡顿'
  },
  {
    img: '06',
    name: '互动白板',
    desc: '矢量化全互动白板，支持多端同时书写，毫秒级同步'
  },
  {
    img: '07',
    name: '互动直播',
    desc: '打造千万级在线并发与全球内容分发网络的“实时互动直播”'
  },
  {
    img: '08',
    name: '云端录制',
    desc: '云端录制无需二次开发，灵活渲染布局'
  },
  // {
  //   img: '09',
  //   name: '即时通讯',
  //   desc: '搭建专属通讯平台，私有化快速部署，保证数据安全可靠'
  // },
];
export const saasProducts = [
  {
    img: '10',
    name: '云会议',
    desc: '真实模拟现场会议，一键开始即时会议'
  },
]